import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Box } from '../Elements'
import { Phone, Logo, Snapchat, Twitter, Instagram, LinkedIn } from '../AllImages'
import { Container, Row } from 'react-bootstrap'
import { ButtonWithIcon } from '../CustomElements'
import { NavDataConfig } from '../../components/projectData/Data'
import { Link } from 'react-scroll'
import { useTranslation } from 'react-i18next'
import { BsJustify, BsX } from "react-icons/bs"
import { useNavigate } from 'react-router-dom'
import { Linkedin } from 'react-bootstrap-icons'
import LangChangeButton from '../../Languages/LangChangeButton'
const Header = () => {
    const navigate = useNavigate()
    const WhatsApp = () => {
        const phoneNumber = '+966531315042';
        const whatsappURL = `https://wa.me/${phoneNumber}`;
        window.open(whatsappURL, '_blank');
    };
    const { t } = useTranslation();
    const [isSticky, setIsSticky] = useState(false);
    const [toggle, setToggle] = useState(false);
    const handleToggle = () => {
        setToggle(!toggle);
        const element = document.querySelector(".nav-bar-list");
        element.classList.toggle("showToggle");
    };
    const SocialLinkSnap = () => {
        window.open('#!', '_blank');
    };
    const SocialLinkLinkedIn = () => {
        window.open('#!', '_blank');
    };
    const SocialLinkInstagram = () => {
        window.open('https://www.instagram.com/sheelandmore?igsh=MW8xMHVzOHhsODUweg==', '_blank');
    };
    const SocialLinkTwitter = () => {
        window.open('https://x.com/sheelandmore?s=11', '_blank');
    };
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 1) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <>
            <HeaderContainer className={`${isSticky ? 'sticky' : ''} container-fluid`}>
                <Container>
                    <Row>
                        <Box className='nav-bar'>
                            <Box className='logoHeader' onClick={() => navigate('/')}>
                                <Logo />
                            </Box>
                            <Box className='d-flex align-items-center gap-4 headerBtnsContainer'>
                                <Box className='d-flex align-items-center socialLinksContainer'>
                                    {/* <Box className='socialLinks'><Snapchat onClick={SocialLinkSnap} /></Box>
                                    <Box className='socialLinks'><LinkedIn onClick={SocialLinkLinkedIn} /></Box> */}
                                    <Box className='socialLinks'><Instagram onClick={SocialLinkInstagram} /></Box>
                                    <Box className='socialLinks'><Twitter onClick={SocialLinkTwitter} /></Box>
                                </Box>
                                <ButtonWithIcon className="headerWhatsapp" border="1px solid var(--white)" icon={Phone} label='+966 531315042' onClick={WhatsApp} />
                                <LangChangeButton border="1px solid var(--border)" color="var(--white)" iconColor="var(--white)" />
                            </Box>
                        </Box>
                    </Row>
                </Container>
            </HeaderContainer>
        </>
    )
}
const HeaderContainer = styled.header`
-webkit-transition: all .3s ease-out 0s;
transition: all .3s ease-out 0s;
position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    width: 100%;
    padding: 24px;
    padding-bottom: 20px;
    .logo{
        cursor:pointer;
    }
    .socialLinks{
        cursor: pointer;
    }
.socialLinksContainer{
    display: flex;
    gap: 16px;
}
.nav-bar{
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
}
    @media (max-width: 767px) {
        .headerBtnsContainer{
            gap: 10px !important;
        }
        .socialLinksContainer{
            display: none !important;
        }
    }
    @media (max-width: 640px) {
        padding-top: 15px;
        padding-bottom: 15px;
        .socialLinksContainer{
            gap: 8px;
        }
    }
    @media (max-width: 550px) {
        .socialLinksContainer{
            display: none !important;
        }
        .logoHeader{
            width: 130px;
            svg{
                width: 100%;
                height: auto;
            }
        }
    }
    @media (max-width: 390px) {
        .headerWhatsapp{
            display: none !important;
        }
    }
`
export default Header
